/* NFR theme chrome — portado do protótipo (prototipo/assets/app.js).
   Fatia 1: header scroll, reveal, menu mobile, countdown.
   Fatia 2: carrinho REAL via Cart AJAX API (/cart/add.js, /cart/change.js) + drawer + toast.
   Fatia 3: busca preditiva (/search/suggest.json),
            vistos recentemente, popup de boas-vindas, banner LGPD. */
(function () {
  var FREE_SHIP_CENTS = 49900; /* DEC-015: grátis a partir de R$499 */
  var FLAT_SHIP_CENTS = 1990; /* DEC-015: frete fixo R$19,90 abaixo do gatilho */

  function money(cents) {
    var v = cents / 100;
    return 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  var PARCELAS_MAX = 6, PARCELA_MIN_CENTAVOS = 5000; /* DEC-027 */

  /* DEC-028: mesma parcela do card Liquid; espaço vazio mantém a grade alinhada. */
  function cardInstallments(cents) {
    var n = Math.min(PARCELAS_MAX, Math.floor(cents / PARCELA_MIN_CENTAVOS));
    return '<div class="card-installments">' +
      (n >= 2 ? n + 'x de ' + money(Math.floor(cents / n)) + ' sem juros' : '') + '</div>';
  }

  function imgW(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---- toast ---- */
  var tT;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'toast';
      t.className = 'toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(tT);
    tT = setTimeout(function () {
      t.classList.remove('show');
    }, 2600);
  }

  /* ---- favoritos (localStorage, mesmo padrão do vistos recentemente) ---- */
  function getFavs() {
    try { return JSON.parse(localStorage.getItem('nfr_favs') || '[]'); } catch (e) { return []; }
  }
  function setFavs(f) {
    try { localStorage.setItem('nfr_favs', JSON.stringify(f.slice(0, 60))); } catch (e) {}
  }
  function isFav(h) {
    return getFavs().indexOf(h) > -1;
  }
  function markFavs(root) {
    (root || document).querySelectorAll('[data-fav]').forEach(function (b) {
      b.classList.toggle('on', isFav(b.getAttribute('data-fav')));
    });
  }
  function toggleFav(h) {
    var f = getFavs();
    var i = f.indexOf(h);
    if (i > -1) { f.splice(i, 1); toast('Removida dos favoritos'); }
    else { f.unshift(h); toast('Salva nos favoritos'); }
    setFavs(f);
    markFavs();
  }

  /* ---- card compartilhado (vistos recentemente, recomendados, favoritos) ---- */
  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 20.3S3.4 15 3.4 9.2C3.4 6.4 5.6 4.3 8.1 4.3c1.6 0 3 .8 3.9 2.2.9-1.4 2.3-2.2 3.9-2.2 2.5 0 4.7 2.1 4.7 4.9 0 5.8-8.6 11.1-8.6 11.1z"/></svg>';
  function cardHTML(p) {
    return (
      '<div class="card"><div class="ph">' +
      '<button class="fav" type="button" data-fav="' + p.handle + '" aria-label="Salvar nos favoritos">' + HEART + '</button>' +
      '<a href="/products/' + p.handle + '">' +
      (p.featured_image ? '<img class="img1" src="' + imgW(p.featured_image, 600) + '" alt="" loading="lazy">' : '') +
      '</a></div>' +
      '<div class="meta"><div class="cat-t">' + esc(p.type || '') + '</div>' +
      '<h4><a href="/products/' + p.handle + '">' + esc(p.title) + '</a></h4>' +
      '<div class="price"><b>' + money(p.price) + '</b>' +
      (p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '') +
      '</div>' + cardInstallments(p.price) + '</div></div>'
    );
  }
  function loadProducts(handles) {
    return Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (ps) {
      return ps.filter(Boolean);
    });
  }

  /* ---- cart drawer ---- */
  function openCart() {
    var d = document.getElementById('drawer');
    var o = document.getElementById('overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
  }
  function closeCart() {
    var d = document.getElementById('drawer');
    var o = document.getElementById('overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
  }

  function renderCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (e) {
      e.textContent = cart.item_count;
    });
    var body = document.getElementById('cartBody');
    var foot = document.getElementById('cartFoot');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML =
        '<div class="empty"><span class="eyebrow">Sacola vazia</span>Adicione peças da coleção.</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items
      .map(function (it) {
        return (
          '<div class="ci"><div class="ci-img">' +
          (it.image ? '<img src="' + imgW(it.image, 200) + '" alt="">' : '') +
          '</div><div><div class="ci-cat">' +
          esc(it.product_type || '') +
          (it.variant_title ? ' · ' + esc(it.variant_title) : '') +
          '</div><h4>' +
          esc(it.product_title) +
          '</h4><div class="ci-price">' +
          money(it.final_line_price) +
          (it.quantity > 1 ? ' × ' + it.quantity : '') +
          '</div><button class="rm" data-cart-remove="' +
          it.key +
          '">Remover</button></div></div>'
        );
      })
      .join('');
    var sub = document.getElementById('subtotal');
    if (sub) sub.textContent = money(cart.items_subtotal_price);
    /* total_price já vem depois do cupom. A loja cobra o frete em cima desse valor. */
    var base = typeof cart.total_price === 'number' ? cart.total_price : cart.items_subtotal_price;
    var frete = base >= FREE_SHIP_CENTS ? 0 : FLAT_SHIP_CENTS;
    var fs = document.getElementById('freeShip');
    if (fs)
      fs.textContent =
        frete === 0
          ? '🎉 Você ganhou frete grátis!'
          : 'Faltam ' + money(FREE_SHIP_CENTS - base) + ' para frete grátis';
    var barra = document.getElementById('freeShipBar');
    if (barra) barra.style.width = Math.min(100, (base * 100) / FREE_SHIP_CENTS) + '%';
    var ship = document.getElementById('cartShip');
    if (ship) ship.textContent = frete === 0 ? 'Grátis' : money(frete);
    if (foot) foot.style.display = 'block';
  }

  function refreshCart(open) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        renderCart(c);
        if (open) openCart();
        return c;
      });
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 }),
    }).then(function (r) {
      if (!r.ok) throw r;
      return r.json();
    });
  }

  /* ---- delegação de cliques ---- */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-fav]'))) {
      e.preventDefault();
      toggleFav(el.getAttribute('data-fav'));
      return;
    }

    if ((el = e.target.closest('[data-cart-remove]'))) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: el.getAttribute('data-cart-remove'), quantity: 0 }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(renderCart);
      return;
    }
    if ((el = e.target.closest('[data-cart-qty]'))) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: +el.getAttribute('data-cart-qty'), quantity: +el.getAttribute('data-qty') }),
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw j;
            return j;
          });
        })
        .then(function () {
          location.reload();
        })
        .catch(function (j) {
          toast((j && j.description) || 'Não deu para alterar a quantidade');
        });
      return;
    }
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshCart(true);
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeCart();
      return;
    }

    if ((el = e.target.closest('[data-copy-coupon]'))) {
      var code = el.getAttribute('data-copy-coupon');
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      toast('Cupom ' + code + ' copiado!');
      return;
    }
    if (e.target.closest('[data-popup-close]') || e.target.id === 'popup') {
      var pop = document.getElementById('popup');
      if (pop) {
        pop.classList.remove('open');
        try { localStorage.setItem('nfr_pop', '1'); } catch (err) {}
        setTimeout(function () { pop.remove(); }, 400);
      }
      return;
    }
  });

  /* formulários de produto → add AJAX + abre o drawer (sem sair da página) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]') || form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function (item) {
        toast((item.product_title || 'Item') + ' na sacola');
        return refreshCart(true);
      })
      .catch(function (r) {
        (r.json ? r.json() : Promise.resolve({})).then(function (d) {
          toast(d.description || 'Não foi possível adicionar');
        });
      });
  });

  /* ---- busca preditiva (página de busca) ---- */
  function initLiveSearch() {
    var input = document.querySelector('[data-live-search]');
    if (!input) return;
    var live = document.querySelector('[data-live-results]');
    var stat = document.querySelector('[data-static-results]');
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) {
        if (live) live.hidden = true;
        if (stat) stat.hidden = false;
        return;
      }
      t = setTimeout(function () {
        fetch(
          '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8'
        )
          .then(function (r) {
            return r.json();
          })
          .then(function (d) {
            if (!live) return;
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            live.hidden = false;
            if (stat) stat.hidden = true;
            live.querySelector('[data-live-count]').textContent = prods.length
              ? prods.length + ' sugestões para "' + q + '" — Enter para a busca completa'
              : 'Nada encontrado para "' + q + '" — Enter para a busca completa';
            live.querySelector('.grid').innerHTML = prods
              .map(function (p) {
                var price = p.price ? 'R$ ' + String(p.price).replace(/\.00$/, '').replace('.', ',') : '';
                return (
                  '<div class="card"><div class="ph"><a href="' + p.url + '">' +
                  (p.image ? '<img class="img1" src="' + imgW(p.image, 600) + '" alt="" loading="lazy">' : '') +
                  '</a></div><div class="meta"><h4><a href="' + p.url + '">' + esc(p.title) + '</a></h4>' +
                  '<div class="price"><b>' + price + '</b></div>' +
                  cardInstallments(Math.round(Number(p.price) * 100)) + '</div></div>'
                );
              })
              .join('');
          });
      }, 300);
    });
  }

  /* ---- vistos recentemente ---- */
  function initRecent() {
    var pdp = document.querySelector('[data-product-handle]');
    if (pdp) {
      try {
        var h = pdp.getAttribute('data-product-handle');
        var r = JSON.parse(localStorage.getItem('nfr_recent') || '[]');
        r = [h].concat(
          r.filter(function (x) {
            return x !== h;
          })
        ).slice(0, 8);
        localStorage.setItem('nfr_recent', JSON.stringify(r));
      } catch (e) {}
    }

    document.querySelectorAll('[data-recent]').forEach(function (wrap) {
      var exclude = wrap.getAttribute('data-exclude');
      var handles = [];
      try {
        handles = JSON.parse(localStorage.getItem('nfr_recent') || '[]');
      } catch (e) {}
      handles = handles
        .filter(function (h) {
          return h && h !== exclude;
        })
        .slice(0, 4);
      if (!handles.length) {
        wrap.style.display = 'none';
        return;
      }
      var grid = wrap.querySelector('.grid');
      loadProducts(handles).then(function (ps) {
        if (!ps.length) {
          wrap.style.display = 'none';
          return;
        }
        grid.innerHTML = ps.map(cardHTML).join('');
        markFavs(wrap);
      });
    });
  }

  /* ---- complete o look (JOT-2366) ----
     1) recomendação nativa complementar; 2) se vazia, regra por tipo de produto.
     MAPA DE REGRAS (editar só aqui): chave = tipo do produto (minúsculo, sem acento);
     valor = coleções (handle base) em ordem de prioridade. Produto feminino/masculino tenta
     "feminino-<base>"/"masculino-<base>" primeiro e cai na coleção geral; peça com a tag do
     gênero oposto é descartada (unissex entra). Feminino usa LOOK_RULES_FEM. Se sobrar menos de 2
     categorias, completa com bonés. Sem coleção ou vazia = categoria ignorada. */
  var LOOK_RULES = {
    camisas: ['bones', 'fivelas', 'cintos'],
    camisetas: ['bones', 'fivelas', 'cintos'],
    polos: ['bones', 'fivelas', 'cintos'],
    regatas: ['bones', 'fivelas', 'cintos'],
    calcas: ['camisas', 'fivelas'],
    shorts: ['camisas', 'fivelas'],
    bones: ['camisas', 'camisetas'],
    chapeus: ['camisas', 'camisetas'],
    moletons: ['bones', 'calcas'],
    moletinhos: ['bones', 'calcas'],
    jaquetas: ['bones', 'calcas']
  };
  /* feminino: regra própria por tipo (não há fivela feminina, então a base é calça/blusa + boné) */
  var LOOK_RULES_FEM = {
    camisas: ['calcas', 'bones', 'fivelas'],
    camisetas: ['calcas', 'bones', 'fivelas'],
    polos: ['calcas', 'bones', 'fivelas'],
    regatas: ['calcas', 'bones', 'fivelas'],
    croppeds: ['calcas', 'bones', 'fivelas'],
    bodys: ['calcas', 'bones', 'fivelas'],
    blusas: ['calcas', 'bones', 'fivelas'],
    calcas: ['regatas', 'bones', 'camisetas', 'croppeds'],
    shorts: ['regatas', 'bones', 'camisetas', 'croppeds']
  };
  var LOOK_COMPLETA = 'bones'; /* categoria que completa quando a regra deixa menos de 2 categorias */
  var LOOK_MAX = 4; /* máximo de peças */
  var LOOK_MIN_CATEGORIAS = 2; /* mínimo de categorias diferentes */
  var LOOK_POR_COLECAO = 12; /* peças lidas por coleção (sobra para o filtro de gênero) */

  function lookNorm(t) {
    return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }
  /* products.json de coleção -> formato do card (/products/<h>.js) */
  function lookToCard(p) {
    var vs = p.variants || [];
    var cents = function (v) { return Math.round(parseFloat(v) * 100); };
    var preco = vs.reduce(function (m, v) { var c = cents(v.price); return m === null || c < m ? c : m; }, null);
    var cmp = vs.reduce(function (m, v) { var c = cents(v.compare_at_price || 0); return c > m ? c : m; }, 0);
    return {
      id: p.id, handle: p.handle, title: p.title, type: p.product_type,
      tags: p.tags || [],
      featured_image: p.images && p.images[0] ? p.images[0].src : '',
      price: preco || 0, compare_at_price: cmp
    };
  }
  function lookGenero(tags) {
    var t = tags.map(lookNorm);
    if (t.indexOf('feminino') > -1) return 'feminino';
    if (t.indexOf('masculino') > -1) return 'masculino';
    return '';
  }
  function lookColecao(handle, self, genero) {
    return fetch('/collections/' + handle + '/products.json?limit=' + LOOK_POR_COLECAO)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        return ((d && d.products) || []).filter(function (p) {
          if (String(p.id) === self.id || p.handle === self.handle) return false;
          if (!(p.variants || []).some(function (v) { return v.available; })) return false;
          var g = lookGenero(p.tags || []);
          return !(genero && g && g !== genero);
        }).map(lookToCard);
      })
      .catch(function () { return []; });
  }
  function lookCategoria(base, self, genero) {
    var tentativas = genero ? [genero + '-' + base, base] : [base];
    return tentativas.reduce(function (acc, h) {
      return acc.then(function (ps) { return ps.length ? ps : lookColecao(h, self, genero); });
    }, Promise.resolve([]));
  }
  /* uma peça de cada categoria por rodada, sem repetir peça */
  function lookEscolher(pools) {
    var out = [], vistos = {}, i = 0, mais = true;
    while (out.length < LOOK_MAX && mais) {
      mais = false;
      for (var k = 0; k < pools.length && out.length < LOOK_MAX; k++) {
        var p = pools[k][i];
        if (p) mais = true;
        if (p && !vistos[p.handle]) { vistos[p.handle] = 1; out.push(p); }
      }
      i++;
    }
    return out;
  }
  function initLook() {
    document.querySelectorAll('[data-look]').forEach(function (wrap) {
      var self = { id: wrap.getAttribute('data-look'), handle: wrap.getAttribute('data-handle') };
      var tipo = lookNorm(wrap.getAttribute('data-type'));
      var genero = lookGenero((wrap.getAttribute('data-tags') || '').split(','));
      var mostrar = function (ps) {
        if (!ps.length) return;
        wrap.querySelector('.grid').innerHTML = ps.map(cardHTML).join('');
        wrap.style.display = '';
        markFavs(wrap);
      };
      fetch('/recommendations/products.json?product_id=' + self.id + '&limit=' + LOOK_MAX + '&intent=complementary')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var nativos = ((d && d.products) || []).filter(function (p) { return p.available !== false; });
          if (nativos.length) return nativos.slice(0, LOOK_MAX);
          var regra = (genero === 'feminino' && LOOK_RULES_FEM[tipo]) || LOOK_RULES[tipo] || [];
          if (regra.indexOf(LOOK_COMPLETA) < 0) regra = regra.concat(LOOK_COMPLETA);
          return Promise.all(regra.map(function (b) { return lookCategoria(b, self, genero); })).then(function (pools) {
            var cheias = pools.filter(function (p) { return p.length; });
            if (cheias.length < LOOK_MIN_CATEGORIAS) return [];
            var ps = lookEscolher(cheias);
            var cats = {};
            ps.forEach(function (p) { cats[lookNorm(p.type)] = 1; });
            return Object.keys(cats).length >= LOOK_MIN_CATEGORIAS ? ps : [];
          });
        })
        .then(mostrar)
        .catch(function () {});
    });
  }

  /* ---- você também pode gostar (recomendações nativas da Shopify) ---- */
  function initRelated() {
    document.querySelectorAll('[data-related]').forEach(function (wrap) {
      var id = wrap.getAttribute('data-related');
      fetch('/recommendations/products.json?product_id=' + id + '&limit=4&intent=related')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var ps = (d && d.products) || [];
          if (!ps.length) {
            wrap.style.display = 'none';
            return;
          }
          wrap.querySelector('.grid').innerHTML = ps.map(cardHTML).join('');
          markFavs(wrap);
        })
        .catch(function () {
          wrap.style.display = 'none';
        });
    });
  }

  /* ---- página de favoritos ---- */
  function initFavorites() {
    document.querySelectorAll('[data-favorites]').forEach(function (wrap) {
      var handles = getFavs().slice(0, 24);
      var vazio = wrap.querySelector('[data-fav-empty]');
      var mostraVazio = function () { if (vazio) vazio.style.display = 'block'; };
      if (!handles.length) return mostraVazio();
      loadProducts(handles).then(function (ps) {
        if (!ps.length) return mostraVazio();
        wrap.querySelector('.grid').innerHTML = ps.map(cardHTML).join('');
        markFavs(wrap);
      });
    });
  }

  /* ---- consentimento: Customer Privacy API da Shopify (JOT-2403) ----
     O banner é o nativo da Shopify (Configurações > Privacidade do cliente). Chama cb quando
     não há banner a responder (região sem exigência) ou quando o visitante escolhe. */
  function aposConsentimento(cb) {
    var feito = false;
    function ok() { if (feito) return; feito = true; cb(); }
    var S = window.Shopify;
    if (!S || !S.loadFeatures) return ok();
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (err) {
      if (err || !S.customerPrivacy || !S.customerPrivacy.shouldShowBanner()) return ok();
      document.addEventListener('visitorConsentCollected', ok, { once: true });
    });
  }

  /* ---- popup de boas-vindas ---- */
  function initPopups() {
    var pop = document.getElementById('popup');
    var seen = null;
    try { seen = localStorage.getItem('nfr_pop'); } catch (e) {}
    var celular = window.matchMedia && matchMedia('(max-width:900px)').matches;
    var semPopup = /\/cart|\/checkout/.test(location.pathname) || (celular && /\/products\//.test(location.pathname));
    /* depois da inscrição a Shopify volta com ?customer_posted=true: o popup abre já com o cupom */
    if (pop && pop.querySelector('[data-popup-ok]')) {
      try { localStorage.setItem('nfr_pop', '1'); } catch (e) {}
      window.scrollTo(0, 0); /* a Shopify volta com a âncora do formulário (rodapé) */
      pop.classList.add('open');
      return;
    }
    if (pop && seen !== '1' && !semPopup) {
      /* o popup só abre depois que o visitante escolheu no banner de cookies da Shopify (JOT-2403) */
      var abrirPopup = function () {
        aposConsentimento(function () { setTimeout(function () { pop.classList.add('open'); }, 700); });
      };
      setTimeout(abrirPopup, +(pop.getAttribute('data-popup-delay') || 40000));
    } else if (pop) {
      pop.remove();
    }
  }

  function init() {
    var group = document.querySelector('.nfr-header-group');
    if (group) {
      function sizeHeader() {
        document.documentElement.style.setProperty('--nfr-header-height', group.offsetHeight + 'px');
      }
      sizeHeader();
      if (window.ResizeObserver) new ResizeObserver(sizeHeader).observe(group);
      else addEventListener('resize', sizeHeader, { passive: true });
    }
    var header = document.getElementById('header');
    if (header && !header.classList.contains('solid')) {
      function updateHeader() {
        header.classList.toggle('scrolled', scrollY > 60);
      }
      updateHeader();
      addEventListener('scroll', updateHeader, { passive: true });
    }

    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(function (el) {
      io.observe(el);
    });

    var mm = document.getElementById('mm');
    document.querySelectorAll('[data-menu-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (mm) mm.classList.toggle('open');
      });
    });

    addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCart();
      }
    });

    /* Countdown de drop com data REAL (setting da seção; sem reset fake) */
    document.querySelectorAll('[data-drop-end]').forEach(function (el) {
      var date = el.getAttribute('data-drop-end');
      var timezone = el.getAttribute('data-drop-timezone');
      // A barra usa Brasília; a faixa existente mantém seu horário local.
      var target = Date.parse(timezone ? date + timezone : date);
      if (timezone && (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(date) ||
          !Number.isFinite(Date.parse(date + 'Z')) ||
          new Date(date + 'Z').toISOString().slice(0, 16) !== date)) target = NaN;
      var box = el.querySelector('.timer');
      if (!Number.isFinite(target) || !box) {
        el.hidden = true;
        el.style.display = 'none';
        return;
      }
      var lastMinute;
      function pad(n) {
        return String(n).padStart(2, '0');
      }
      function tick() {
        var diff = Math.max(0, target - Date.now());
        if (diff === 0) {
          el.hidden = true;
          el.style.display = 'none';
          return;
        }
        el.hidden = false;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var d = Math.floor(h / 24);
        box.innerHTML =
          '<span>' + pad(d) + '<small>dias</small></span>' +
          '<span>' + pad(h % 24) + '<small>hrs</small></span>' +
          '<span>' + pad(m) + '<small>min</small></span>' +
          '<span>' + pad(s) + '<small>seg</small></span>';
        var minute = Math.floor(diff / 60000);
        if (minute !== lastMinute) {
          box.setAttribute('aria-label', 'Tempo restante: ' + d + (d === 1 ? ' dia, ' : ' dias, ') +
            (h % 24) + (h % 24 === 1 ? ' hora e ' : ' horas e ') + m + (m === 1 ? ' minuto' : ' minutos'));
          lastMinute = minute;
        }
        setTimeout(tick, 1000);
      }
      tick();
    });

    initLiveSearch();
    initRecent();
    initRelated();
    initLook();
    initFavorites();
    markFavs();
    initPopups();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
